export const SN_LOYALTY_PROGRAM = 'loyalty'
export const LOYALTY_TIERS = `${SN_LOYALTY_PROGRAM}/LOYALTY_TIERS`
export const LOYALTY_CUSTOMER = `${SN_LOYALTY_PROGRAM}/LOYALTY_CUSTOMER`
export const LOYALTY_DASHBOARD = `${SN_LOYALTY_PROGRAM}/LOYALTY_DASHBOARD`
export const LOYALTY_CART_SET = `${SN_LOYALTY_PROGRAM}/LOYALTY_CART_SET`
export const LOYALTY_CART_ADD_ITEM = `${SN_LOYALTY_PROGRAM}/LOYALTY_CART_ADD_ITEM`
export const LOYALTY_CART_DEL_ITEM = `${SN_LOYALTY_PROGRAM}/LOYALTY_CART_DEL_ITEM`
export const LOYALTY_CART_UPD_ITEM = `${SN_LOYALTY_PROGRAM}/LOYALTY_CART_UPD_ITEM`
